// extracted by mini-css-extract-plugin
export default {"main-container":"TheLayout_main-container__nJM6K"};